/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PhoneStatusResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * The firm's connection, or none. Readable by any member; tenant id by admins.
 * @summary Get Phone Status
 */
export const getPhoneStatus = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<PhoneStatusResponse>(
      {url: `/phone/status`, method: 'GET', signal
    },
      options);
    }




export const getGetPhoneStatusQueryKey = () => {
    return [
    `/phone/status`
    ] as const;
    }


export const getGetPhoneStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPhoneStatus>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPhoneStatus>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPhoneStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPhoneStatus>>> = ({ signal }) => getPhoneStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPhoneStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPhoneStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPhoneStatus>>>
export type GetPhoneStatusQueryError = unknown


/**
 * @summary Get Phone Status
 */

export function useGetPhoneStatus<TData = Awaited<ReturnType<typeof getPhoneStatus>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPhoneStatus>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPhoneStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






